import { render, staticRenderFns } from "./NotificationBadge.vue?vue&type=template&id=0e3dcadb&scoped=true"
import script from "./NotificationBadge.vue?vue&type=script&lang=js"
export * from "./NotificationBadge.vue?vue&type=script&lang=js"
import style0 from "./NotificationBadge.vue?vue&type=style&index=0&id=0e3dcadb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3dcadb",
  null
  
)

export default component.exports